<template>
  <v-stepper v-model="e6" vertical>
    <v-stepper-step :complete="e6 > 1 || former.title!=''" edit-icon="$vuetify.icons.complete" editable step="1" color="primary lighten-2">
      Title
    </v-stepper-step>

    <v-stepper-content step="1">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          v-model="former.title"
          :counter="30"
          :rules="nameRules"
          label="Title"
          required
          clearable
          clear-icon="mdi-close-circle"
        ></v-text-field>

        <v-text-field
          v-model="former.description"
          label="Subheading (optional)"
          clearable
          clear-icon="mdi-close-circle"
        ></v-text-field>
      </v-form>
      <v-btn color="#27aae1" style="color:#fff" @click="stepper(2)"> Continue </v-btn>
    </v-stepper-content>

    <v-stepper-step :complete="e6 > 2 || logo !=''" edit-icon="$vuetify.icons.complete" step="2" :editable="this.kb_id != ''" color="primary lighten-2">
      Logo
    </v-stepper-step>

    <v-stepper-content step="2">
      Header/Footer Theme:
      <v-btn text @click="former.dark_theme = !former.dark_theme"
        ><v-icon>mdi-invert-colors</v-icon></v-btn
      ><br /><br />

      <dropzone
        v-if="logo == '' || replace_logo"
        v-on:bubba="bubbaEmit"
        v-bind:organization_id="organization_id"
        :key="componentKey"
      ></dropzone>
      <v-tooltip right v-else>
        <template v-slot:activator="{ on, attrs }">
          <v-img
            v-bind="attrs"
            v-on="on"
            @click="replace_logo = !replace_logo"
            :src="imgr"
            max-width="100px"
          />
        </template>
        <span>Click to replace logo</span>
      </v-tooltip>
      <br /><br />
      <v-btn color="#27aae1" style="color:#fff" @click="e6 = 3"> Continue </v-btn>
    </v-stepper-content>

    <v-stepper-step :complete="e6 > 3 || (buttonx.label!='')" edit-icon="$vuetify.icons.complete" step="3" :editable="this.kb_id != ''" color="primary lighten-2">
      Buttons
    </v-stepper-step>

    <v-stepper-content step="3">
      <ButtonDialog
        v-bind:button="buttonx"
        v-bind:sequence="1"
        v-on:button="buttonEmit"
      />
      <br />
      <ButtonDialog
        v-bind:button="buttony"
        v-bind:sequence="2"
        v-on:button="buttonEmit"
      />
      <br />

      <v-btn color="#27aae1" style="color:#fff" @click="stepper(4)"> Continue </v-btn>
    </v-stepper-content>

    <v-stepper-step step="4" :editable="this.kb_id != ''" edit-icon="$vuetify.icons.complete" :complete="e6 > 4 || category_value.length>0"  color="primary lighten-2">
      Category Selection
    </v-stepper-step>
    <v-stepper-content step="4">
      <v-select
        id="category_selector"
        v-model="category_value_input"
        :items="categories_list"
        item-text="title"
        item-value="id"
        return-object
        multiple
        solo
      ></v-select>

      <v-btn color="#27aae1" style="color:#fff" @click="e6 = 5"> Continue </v-btn>
    </v-stepper-content>

    <v-stepper-step step="5" :editable="this.kb_id != ''" edit-icon="$vuetify.icons.complete" :complete=" (
                  custom_domain_verified != null)" color="primary lighten-2">
      Domain Settings
    </v-stepper-step>
    <v-stepper-content step="5">
      <v-row justify="center">
        <v-dialog v-model="domain_dialog" persistent max-width="600px">
          <v-card>
            <v-card-title primary>
              <span class="headline">Add Custom Domain</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      solo
                      type="url"
                      :rules="[rules.required, rules.url]"
                      prepend-inner-icon="mdi-web"
                      label="www.yourdomain.com*"
                      required
                      v-model="custom_domain"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="domain_dialog = false">
                Close
              </v-btn>
              <v-btn color="blue darken-1" text @click="createDomainMapping">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-row justify="center">
        <v-dialog v-model="mapping_dialog" persistent max-width="490">
          <v-card>
            <v-card-title class="headline"> DNS Information </v-card-title>
            <v-card-text>
              <span
                v-if="
                  custom_domain_verified == null || custom_domain_verified == ''
                "
              >
                This domain has been added to the project and is pending DNS
                validation.
                <p>
                  <br />Please add (or verify) the following record in your DNS:
                </p>
              </span>
              <span v-else>
                <v-icon>shield-key-outline</v-icon> DNS Validated Successfully
              </span>
              <br />
              <v-simple-table dark>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td>CNAME</td>
                      <td>{{ custom_domain }}</td>
                      <td>
                        {{ org_name_slugified }} <v-icon>mdi-copy</v-icon>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="black darken-1"
                text
                @click="mapping_dialog = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="390">
          <v-card>
            <v-card-title class="headline">
              Remove domain mapping?
            </v-card-title>
            <v-card-text>
              Remove {{ custom_domain }} mapping? <br /><br />You will have to
              recreate the mapping if you proceed.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="dialog = false">
                Cancel
              </v-btn>
              <v-btn color="green darken-1" text @click="removeDomainMapping">
                Remove Mapping
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <br /><br />
      <div>
         <v-btn-toggle mandatory v-model="former.uses_custom_domain">
        <v-btn :color="!former.uses_custom_domain?'#27aae1':'primary'" style="color:#fff" :disabled="former.published" :value="false">
          fyiio.com
        </v-btn>
        <v-btn :color="former.uses_custom_domain?'#27aae1':'primary'" style="color:#fff" :disabled="former.published" :value="true">
          Custom domain
        </v-btn>
      </v-btn-toggle>
        <div v-if="!former.uses_custom_domain">
          <span class="caption" v-if="former.published"
            >Your fyiio domain:</span
          >
          <span class="caption" v-else
            ><br>Once published, your knowledge base will be available here:</span
          >
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
            </template>
            <span>Publishing allows others to access the knowledge base</span>
          </v-tooltip><br><br>
          <v-text-field
            filled
            readonly
            id="copier"
            v-model="org_name_slugified"
            :prepend-inner-icon="former.published ? 'mdi-content-copy' : ''"
            :append-icon="former.published ? 'mdi-launch' : ''"
            type="text"
            @click:prepend-inner="copyUrl"
            @click:append="launcher"
          ></v-text-field>
        </div>
        <div v-else>
          <span class="caption" v-if="former.published"
            >Your custom domain:</span
          >
          <span class="caption" v-else
            ><br>Once published, your knowledge base will be available on a
            subdomain of your website.<br/><br/></span
          >
          {{former.published}}
          <v-text-field
            label="Knowledge base location"
            hint="Keep it short and memorable"
            persistent-hint
            :rules="[rules.required, rules.url]"
            prepend-inner-icon="mdi-web"
            id="copierx"
            v-model="custom_domain"
            append-icon="mdi-trash-can-outline"
            filled
            :readonly="former.published"
            type="text"
            @click:append="former.published ? disallowed():clearCustomDomainConfirm()"
          ></v-text-field>
          <br />
          <v-btn text medium class="float:left" color="#27aae1" @click="mapping_dialog=true"> DNS Settings </v-btn>
          <v-btn text medium class="" color="#27aae1" @click="former.published? (e6=6):createDomainMapping()"> Continue </v-btn>
        </div>
      </div>
      <!--
      <v-btn
        text
        v-if="former.uses_custom_domain"
        :disabled="custom_domain == null || custom_domain == ''"
        
        small
        color="primary"
        @click="domain_dialog = true"
      >
        <v-icon small>mdi-plus</v-icon>
        DNS settings
      </v-btn>
      -->
      <!--
      <v-btn
        v-else
        outlined
        small
        color="primary"
        @click="mapping_dialog = true"
      >
        <br /><v-icon small flat>mdi-plus</v-icon>
        View DNS Settings
      </v-btn> -->
      &nbsp; &nbsp;
      <span v-if="former.publised && custom_domain != null && custom_domain != ''"
        ><br /><v-icon small red>mdi-lock-outline</v-icon> Status: verifying
        domain ownership</span
      >
    </v-stepper-content>
    <v-stepper-step step="6" :editable="this.kb_id != ''" :complete="former.published" edit-icon="$vuetify.icons.complete" color="primary lighten-2">
      Preview and Publish
    </v-stepper-step>
    <v-stepper-content step="6">
     
      <h3>Knowledge base location</h3>
      <span>{{ former.uses_custom_domain ? custom_domain : org_name_slugified }}</span>
      <br /><br v-if="!former.uses_custom_domain" />

   <v-icon v-if="former.published && !former.uses_custom_domain"
      color="teal darken-2" large
      class="left">
      mdi-lightbulb-on-outline
    </v-icon>
    <p v-if="former.published && !former.uses_custom_domain">fyiio is provisioning your knowledge base location. This should be complete shortly.</p>
      <br />

      <v-icon v-if="former.published && former.uses_custom_domain"
      color="green darken-2" large
      class="left">
      mdi-check
    </v-icon>
    <p v-if="former.published && former.uses_custom_domain">Knowledge base location specified </p>


      <v-icon v-if="former.published && former.uses_custom_domain"
      color="red darken-2" large
      class="left">
      mdi-close
    </v-icon>
    <p v-if="former.published && former.uses_custom_domain">Verified domain ownership (We'll reach out to you)</p>

      <v-icon v-if="former.published && former.uses_custom_domain"
      color="red darken-2" large
      class="left">
      mdi-close
    </v-icon>
    <p v-if="former.published && former.uses_custom_domain">Verified DNS Settings (See <strong>Domain Settings</strong> above)</p>
        <p v-if="former.published && former.uses_custom_domain">Domain changes can take up to 24 hours to apply, although it generally happens much faster. </p>
      <br />
       
      <Preview
        v-bind:former="former"
        v-bind:imgr="imgr"
        v-on:dialogCloser="dialogCloseEmit"
        v-bind:preview_dialog="preview_dialog"
        v-bind:button1="buttonx"
        v-bind:button2="buttony"
        v-bind:client="client"
        v-bind:cards="cards"
      ></Preview>
      
        <v-btn text color="#27aae1" large style="margin-top:10px;float:left"
        @click="openPreview()">
          Preview
          
        </v-btn>
      <v-switch
        style="float: right"
        v-model="former.published"
        :label="former.published ? 'Published!' : 'Ready to publish?'"
      ></v-switch>
    </v-stepper-content>
    <v-dialog
      v-model="updating_categories_dialog"
      transition="dialog-top-transition"
      persistent
      width="400"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <br>
          <h2>Updating category content</h2>
          
          <br><br>Please stand by
          <br>
          <br>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
          <br>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-stepper>
  
  
</template>


<script>
import Dropzone from "./Dropzone";
import Preview from "./Preview";
import ButtonDialog from "./ButtonDialog";
import { gql } from "@apollo/client/core";
import cognitoAuth from "@/plugins/cognito";
export default {
  components: {
    Dropzone,
    ButtonDialog,
    Preview,
  },
  mounted() {
    this.$root.$on("logo", (data) => {
      this.saveLogo(data);
    });
    let self = this;
    self.custom_domain = this.persisted_custom_domain;
    self.custom_domain_verified = this.persisted_custom_domain_verified;

    this.$cognitoAuth.getIdToken((err, idToken) => {
      if (err) {
        console.error("App: Couldn't get the session:", err, err.stack);
        return;
      }
      self.idToken = idToken;
    });
    //TODO - Review or remove by 3/1/2021
    cognitoAuth.getUserAttributes(function (err, user_attributes) {
      //console.log("User attributes", user_attributes);
      self.organization_id = user_attributes["custom:organization_id"];
      self.organization_name = user_attributes["custom:organization"];
      self.componentKey += 1;
      self.email = user_attributes;
    });
    if (self.$route.params.id != undefined) {
      if (self.imgr.indexOf("placeholder") >= 0) {
        self.e6 = 2;
      } else {
        self.e6 = 3;
      }
    }
  },
  props: [
    "keycloak",
    "former",
    "client",
    "kb_id",
    "id_token",
    "buttonx",
    "buttony",
    "categories_list",
    "category_value",
    "imgr",
    "cards",
    "persisted_custom_domain",
    "persisted_custom_domain_verified",
    "page_categories_loaded",
    "logo",
    "replace_logo",
    "category_content_updated"
  ],
  data: () => ({
    updating_categories_dialog:false, //each category update is a discrete event. We need to let it complete.
    preview_dialog: false, 
    switch1: false,
    self: this,
    placeholder_img: "placeholder.jpg",
    fully: false,
    organization_id: "",
    organization_name: "",
    email: "",
    e6: 1,
    valid: true,
    componentKey: 0,
    mapping_dialog: false,
    dialog: false,
    domain_dialog: false,
    custom_domain: "",
    publish: false,
    custom_domain_verified: "",
    kburl: "",
    nameRules: [],

    rules: {
      required: (value) => !!value || "Required.",
      counter: (value) => value.length <= 20 || "Max 20 characters",
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
      url: (value) => {
        const expression = /[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)?/gi;
        var regex = new RegExp(expression);
        return regex.test(value) || "Invalid url.";
      },
    },
  }),
  watch: {
    "category_content_updated": function(newValue, oldValue){
      let self=this;
      console.log(newValue, oldValue)
      if(newValue==true){
        self.updating_categories_dialog=false;
        self.$emit("categoryContentUpdated");
      }
    },
    "former.uses_custom_domain": function(newValue, oldValue){
      console.log("update former.uses_custom_domain, newValue:", newValue, "oldvalue:", oldValue)
      this.saveCustomDomainStatus()
    },
    "former.published": function (newValue, oldValue) {
      let self=this;
      console.log("former publised changed from ", oldValue, " to ", newValue)
      this.client
        .mutate({
          mutation: gql`
            mutation changePublishedStatus($id: uuid!, $published: Boolean!) {
              update_knowledge_base_by_pk(
                pk_columns: { id: $id }
                _set: { published: $published }
              ) {
                id
                published
              }
            }
          `,
          variables: {
            id: this.kb_id,
            published: this.former.published,
          },
        })
        .then((result) => {
          console.log("updated status!", result);
          self.$forceUpdate();
        });
    },
    "former.dark_theme": function (newValue, oldValue) {
      console.log("old:", oldValue);
      console.log("new:", newValue);
      this.client
        .mutate({
          mutation: gql`
            mutation changeTheme($id: uuid!, $dark_theme: Boolean!) {
              update_knowledge_base_by_pk(
                pk_columns: { id: $id }
                _set: { dark_theme: $dark_theme }
              ) {
                id
                dark_theme
              }
            }
          `,
          variables: {
            id: this.kb_id,
            dark_theme: newValue,
          },
        })
        .then((result) => {
          this.former.dark_theme = newValue;
          console.log("Emitting new dark_theme value", result);
          this.$emit("themeEmit", newValue);
        });
    },
  },
  computed: {
    org_name_slugified: function () {
      return `${this.slugify(this.organization_name)}.fyiio.com`;
    },
    category_value_input: {
      get: function () {
        return this.category_value;
      },
      set: function (newValue) {
        if (this.page_categories_loaded) {
          this.updating_categories_dialog=true;
          console.log("Emitting new category value", newValue);
          this.$emit("categories", newValue, true);
        }
      },
    },
  },
  methods: {
    saveCustomDomainStatus(){
      this.client
        .mutate({
          mutation: gql`
            mutation changeUsesCustomDomain($id: uuid!, $uses_custom_domain: Boolean!) {
              update_knowledge_base_by_pk(
                pk_columns: { id: $id }
                _set: { uses_custom_domain: $uses_custom_domain }
              ) {
                id
                uses_custom_domain
              }
            }
          `,
          variables: {
            id: this.kb_id,
            uses_custom_domain: this.former.uses_custom_domain,
          },
        })
        .then((result) => {
          console.log("uses custom domain updated", result);
        });
    },
    dialogCloseEmit(valzer){
      console.log("Closing dialog", valzer)
      this.preview_dialog=false
    },
    openPreview(){
      this.preview_dialog=true;
      this.$forceUpdate();
    },
    launcher(){
      window.open('https://' + this.org_name_slugified, "_blank")
    },
    createDomainMapping(){
      this.domain_dialog = false;
      this.client
        .mutate({
          mutation: gql`
            mutation createOrUpsertCustomDomain($knowledge_base_id: uuid!, $custom_domain: String!) {
                insert_custom_domain_one(
                  object: {
                    knowledge_base_id: $knowledge_base_id, 
                    custom_domain: $custom_domain
                  }, on_conflict: {
                    constraint: custom_domain_custom_domain_key, 
                    update_columns: [custom_domain]
                  }
                ){
                  id
                  custom_domain
                }
            }
          `,
          variables: {
            knowledge_base_id: this.kb_id,
            custom_domain: this.custom_domain,
          },
        })
        .then((result) => {
          console.log("saved custom domain!", result);
          this.e6=6
          //this.mapping_dialog = true;
        });

    },
    createDomainMappingOld() {
      this.domain_dialog = false;
      this.client
        .mutate({
          mutation: gql`
            mutation createCustomDomain($id: uuid!, $custom_domain: String!) {
              update_knowledge_base_by_pk(
                pk_columns: { id: $id }
                _set: { custom_domain: $custom_domain }
              ) {
                id
              }
            }
          `,
          variables: {
            id: this.kb_id,
            custom_domain: this.custom_domain,
          },
        })
        .then((result) => {
          console.log("here!", result);
          this.mapping_dialog = true;
        });
    },
    removeDomainMapping() {
      this.dialog = false;
      this.custom_domain = "";
      this.client
        .mutate({
          mutation: gql`
            mutation removeCustomDomain($id: uuid!) {
              delete_custom_domain(where: {knowledge_base_id: {_eq: $id}})
              {
                returning{
                  id
                }
              }
            }
          `,
          variables: {
            id: this.kb_id,
          },
        })
        .then((result) => {
          console.log("here!", result);
        });
    },
    disallowed(){
      alert("Your Knowledge Base is in Published Mode. Switch to Draft mode and then you can reassign the domain if desired. ")
    },
    clearCustomDomainConfirm() {
      this.dialog = true;
    },
    slugify(str) {
      str = str.replace(/^\s+|\s+$/g, ""); // trim
      str = str.toLowerCase();
      // remove accents, swap ñ for n, etc
      var from = "ãàáäâáº½èéëêìíïîõòóöôùúüûñç·/_,:;";
      var to = "aaaaaeeeeeiiiiooooouuuunc------";
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
      }
      str = str
        .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
        .replace(/\s+/g, "-") // collapse whitespace and replace by -
        .replace(/-+/g, "-"); // collapse dashes
      return str;
    },
    copyUrl() {
      var copyText = document.getElementById("copier");
      /* Select the text field */
      copyText.select();
      copyText.setSelectionRange(0, 99999); /* For mobile devices */
      /* Copy the text inside the text field */
      document.execCommand("copy");
      /* Alert the copied text */
      alert("Copied the text: " + copyText.value);
    },
    stepper(nextStep) {
      console.log("NextStep is ", nextStep);
      if (nextStep == 2) {
        this.saveTitle();
      } else if (nextStep == 4) {
        this.saveButton();
      }
      this.e6 = nextStep;
    },
    saveButton() {
      //console.log("kb_id is :", this.kb_id);
      //console.log("In savebutton, button1 is", this.buttonx);
      //console.log("In saveButton, button2 is:", this.buttony);
      let header_buttons = {};
      header_buttons.header_button_1 = this.buttonx;
      header_buttons.header_button_2 = this.buttony;
      //this.$emit('buttons', header_buttons)
      this.client
        .mutate({
          mutation: gql`
            mutation saveButton($id: uuid!, $button: jsonb!) {
              update_knowledge_base_by_pk(
                pk_columns: { id: $id }
                _set: { header_buttons: $button }
              ) {
                id
                header_buttons
              }
            }
          `,
          variables: {
            id: this.kb_id,
            button: header_buttons,
          },
        })
        .then((result) => {
          console.log("buttons updated!", result);
        });
    },
    saveLogo(logo) {
      //console.log("kb_id is :", this.kb_id);
      this.client
        .mutate({
          mutation: gql`
            mutation saveLogo($id: uuid!, $logo: String!) {
              update_knowledge_base_by_pk(
                pk_columns: { id: $id }
                _set: { logo: $logo }
              ) {
                id
              }
            }
          `,
          variables: {
            id: this.kb_id,
            logo: logo,
          },
        })
        .then((result) => {
          console.log("logo saved", result);
        });
    },
    saveTitle() {
      if (this.kb_id != "") {
        //console.log("kb_id is :", this.kb_id);
        this.client
          .mutate({
            mutation: gql`
              mutation saveTitle(
                $id: uuid!
                $title: String!
                $description: String
              ) {
                update_knowledge_base_by_pk(
                  pk_columns: { id: $id }
                  _set: { title: $title, description: $description }
                ) {
                  id
                  title
                  description
                }
              }
            `,
            variables: {
              id: this.kb_id,
              title: this.former.title,
              description: this.former.description,
            },
          })
          .then((result) => {
            console.log("Updated title/description!", result.data);
          });
      } else {
        this.client
          .mutate({
            mutation: gql`
              mutation saveKnowledgeBase(
                $title: String!
                $description: String
                $organization_id: uuid!
              ) {
                insert_knowledge_base_one(
                  object: {
                    title: $title
                    description: $description
                    organization_id: $organization_id
                  }
                ) {
                  id
                }
              }
            `,
            variables: {
              title: this.former.title,
              description: this.former.description,
              organization_id: this.organization_id,
            },
          })
          .then((result) => {
            console.log(
              "Setting kb_id to ",
              result.data.insert_knowledge_base_one.id
            );
            this.$emit("kb_id", result.data.insert_knowledge_base_one.id);
          });
      }
    },

    bubbaEmit(valzer) {
      this.$emit("bubba", valzer);
    },
    buttonEmit(button, sequence) {
      if (sequence == 1) {
        this.buttonx = button;
      } else {
        this.buttony = button;
      }

      this.$emit("button", button, sequence);
      this.saveButton();
    },
    //emitCategoryChange(valzer){
    //  this.$emit('categories', valzer)
    //}
  },
};
</script>
<style scoped>
.left {
    float: left;
    margin-right: .5em;
    margin-top:15px
}
.right {
    float: right;
    margin-left: .5em;
}
p {
    margin-bottom: 1.0em;
    overflow: hidden; /* this is what keep the <p> from wrapping */
}
</style>